import React from "react"
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from "@mui/material";
import { Add, List, Edit, Logout, Delete } from '@mui/icons-material';
import handleLogout from "../../utils/handleLogout";
import handleDelete from "../../utils/handleDelete";

const NavigationMenu = (props) => {
    const { logoutUrl, csrf, newRecipe, recipesPath, editRecipePath, deleteRecipePath } = props

    return (
        <SpeedDial sx={{position: 'fixed', bottom: 16, right: 16}} icon={<SpeedDialIcon />} ariaLabel="Navigation">
            <SpeedDialAction
              key="Logout"
              icon={<Logout/>}
              tooltipTitle="Logout"
              onClick={() => handleLogout(logoutUrl, csrf)} />
            <SpeedDialAction
              key="New Recipe"
              icon={<Add />}
              tooltipTitle="Create new Recipe"
              href={newRecipe} />
            <SpeedDialAction 
              key="All Recipes"
              icon={<List />}
              tooltipTitle="List all Recipes"
              href={recipesPath} />
            <SpeedDialAction 
              key="Edit Recipe"
              icon={<Edit />}
              tooltipTitle="Edit Recipe"
              href={editRecipePath}
              sx={{display: editRecipePath ? 'inline-flex' : 'none' }} />
            <SpeedDialAction 
              key="Delete Recipe"
              icon={<Delete />}
              tooltipTitle="Delete Recipe"
              onClick={() => handleDelete(deleteRecipePath, csrf)}
              sx={{display: deleteRecipePath ? 'inline-flex' : 'none' }} />
        </SpeedDial>
    );
}

export default NavigationMenu
